module.exports = __webpack_public_path__ + "static/media/mrpostman.ef48f9ad.mp3";